import type { GenericTranslationsObject } from '@payloadcms/translations'

export const en: GenericTranslationsObject = {
  $schema: '../translation-schema.json',
  'plugin-redirects': {
    customUrl: 'Custom URL',
    documentToRedirect: 'Document to redirect to',
    fromUrl: 'From URL',
    internalLink: 'Internal link',
    redirectType: 'Redirect Type',
    toUrlType: 'To URL Type',
  },
}
